import React, { Component } from 'react';
import './index.css';

// Displaying calculated classification based on evaluation data, defaulting to 'None' if null
export default class CalculatedClassification extends Component {
  render() {
    return (
      <div className="calculatedClassification">
        Calculated Classification: {this.props.calculatedClassification || 'None'}
      </div>
    );
  }
}
